export enum WindowSize {
    LARGE,
    MEDIUM,
    SMALL
}


// WEBPACK FOOTER //
// ./src/utils/WindowSize.tsx